import { render, staticRenderFns } from "./ValoracionesDetalles.vue?vue&type=template&id=63f58290&"
import script from "./ValoracionesDetalles.vue?vue&type=script&lang=js&"
export * from "./ValoracionesDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports